import { forwardRef, type ReactNode } from 'react';

import { cn } from '../../utils';

import { Input, type InputProps } from './Input';
import { iconVariants } from './inputVariants';

export interface InputWithIconProps extends InputProps {
  icon?: ReactNode;
  inputClassName?: string;
  iconClassName?: string;
}

export const InputWithIcon = forwardRef<HTMLInputElement, InputWithIconProps>(
  (
    {
      icon,
      variant = 'default',
      className,
      inputClassName,
      iconClassName,
      id,
      ...props
    },
    ref,
  ) => {
    const iconPadding = icon
      ? {
          extraSmall: 'pl-8',
          small: 'pl-9',
          default: 'pl-9',
          large: 'pl-10',
        }[variant || 'default']
      : '';

    return (
      /**
       * This `<div>` is a wrapper that hugs the input's dimensions and helps with
       * positioning of the icon.
       */
      <div className={cn('relative w-fit h-fit', className)}>
        <Input
          id={id}
          variant={variant}
          className={cn(iconPadding, inputClassName)}
          {...props}
          ref={ref}
        />
        {icon && (
          <div className={cn(iconVariants({ variant }), iconClassName)}>
            {icon}
          </div>
        )}
      </div>
    );
  },
);
